import { Dispatch } from 'react';

import { FormState, UseFormRegister, UseFormSetValue } from 'react-hook-form';

import Calendar from '@calendar/components/Calendar';
import { CreateEvent } from '@event/types';
import useIsMounted from '@utils/hooks/isMounted';

import Card from './Card';

export interface EventProps {
  register: UseFormRegister<CreateEvent>;
  setValue: UseFormSetValue<CreateEvent>;
  formState: FormState<CreateEvent>;
  photoId: number;
  setPhotoId: Dispatch<React.SetStateAction<number>>;
}

const Event = ({
  register,
  setValue,
  formState,
  photoId,
  setPhotoId,
}: EventProps) => {
  const isMounted = useIsMounted();

  return (
    <div className="relative w-full">
      <Card
        register={register}
        setValue={setValue}
        formState={formState}
        setPhotoId={setPhotoId}
        photoId={photoId}
      />
      {isMounted && <Calendar />}
    </div>
  );
};

export default Event;
